import { useTranslation } from 'react-i18next';
import type { ITableActionsProps } from './ITableActionsProps';
import { ToolbarGlyph } from './ToolbarGlyph';
import type { ToolbarGlyphName } from './ToolbarGlyphName';

/**
 * Ліва група панелі списку (прототип v4): «+ Створити <запис>» (лише з правом редагування) · редагувати, копіювати (з можливістю `edit`),
 * видалити вибрані (з можливістю `delete`; 32×32, недоступні без вибору; без права — сховані, як у режимі спостерігача) · «Вибрати все /
 * Зняти весь вибір» і «Вибрано: N» · експорт CSV (вибрані або всі; без права — недоступний із поясненням у підказці), друк, скидання
 * фільтрів (лише з активними) · визначення модуля.
 */
export function TableActions({ actions, createText, selected, filtersActive, onReset, canExport, canCreate, canEdit = true, canDelete = true }: ITableActionsProps) {
  const { t } = useTranslation();
  const none = selected === 0;
  const icon = (name: ToolbarGlyphName, label: string, onClick: () => void, opts: { disabled?: boolean; danger?: boolean; reason?: string } = {}) => (
    <button type="button" className={opts.danger ? 'lv-ibtn lv-ibtn--danger' : 'lv-ibtn'} aria-label={label} title={opts.reason ? `${label} — ${opts.reason}` : label}
      disabled={opts.disabled} onClick={onClick}>
      <ToolbarGlyph name={name} />
    </button>
  );
  return (
    <>
      {canCreate && <button type="button" className="lv-create" onClick={actions.create}>{createText}</button>}
      {canEdit && icon('edit', t('listbar.editSelected'), actions.edit, { disabled: none })}
      {canEdit && icon('copy', t('listbar.copySelected'), actions.copy, { disabled: none || actions.busy })}
      {canDelete && icon('delete', t('listbar.deleteSelected'), actions.remove, { disabled: none, danger: true })}
      {(canCreate || canEdit || canDelete) && <span className="lv-toolbar__sep" aria-hidden="true" />}
      <button type="button" className="lv-tbtn" disabled={actions.busy} onClick={actions.toggleAll}>{actions.allSelected ? t('listbar.deselectAll') : t('listbar.selectAll')}</button>
      {!none && <span className="lv-toolbar__sel">{t('listbar.selected', { count: selected })}</span>}
      <span className="lv-toolbar__sep" aria-hidden="true" />
      {icon('export', t('listbar.exportCsv'), actions.exportCsv, { disabled: actions.busy || !canExport, reason: canExport ? undefined : t('listViews.noExport') })}
      {icon('print', t('listbar.print'), actions.print)}
      {filtersActive && icon('reset', t('listbar.reset'), onReset)}
      <span className="lv-toolbar__sep" aria-hidden="true" />
      {icon('definition', t('listbar.definition'), actions.definition)}
    </>
  );
}
